import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import {V1ProjectPlanPhaseMilestoneReferenceIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import {v4 as uuidv4} from "uuid";


class ProjectPlanPhaseMilestoneReferenceLookupEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();
        let primaryIntegrationComponent = "ProjectPlanPhaseMilestoneReference";

        this.notifyLoadStartListeners();

        let idocRequest = this.getIDOCRequest() ?? "v1.ProjectPlanPhaseMilestoneReference-001";
        let idocResponse = this.getIDOCResponse() ?? "v1.ProjectPlanPhaseMilestoneReference-001";

        let QBE = {
            "ShifamedMessage": {
                "-idoc": idocResponse,
                "-id": uuidv4(),
                [primaryIntegrationComponent]: {
                    '_attributes': {
                        'limit': pageSize,
                        'sort': this.getFormattedSortSpecification(),
                        'offset': (page - 1) * pageSize
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "primary",
                                "Operator": "AND",
                                "Type": "QueryGroup",
                                "Membership": {
                                    "Member": []
                                }
                            }
                        ]
                    }
                }
            }
        }

        if (foreignKey) {
            if (this.getEnterpriseObject() !== null) {
                let relationship = this.getRelationshipForChildEnterpriseComponent(this);

                if (relationship) {
                    QBE.ShifamedMessage[primaryIntegrationComponent].QueryGroups.QueryGroup[0].Membership.Member.push({
                        "Type": "Attribute",
                        "Name": relationship.getSourceAttribute(),
                        "Value": foreignKey,
                        "Operator": "EQUAL"
                    })
                }
            }
        }

        if (this.getSearchSpecification() !== null) {
            let keys = Object.keys(this.getSearchSpecification());
            for (let i = 0; i < keys.length; i++) {
                let key = keys[i];

                QBE.ShifamedMessage[primaryIntegrationComponent].QueryGroups.QueryGroup[0].Membership.Member.push({
                    "Type": "Attribute",
                    "Name": key,
                    "Value": this.getSearchSpecification()[key],
                    "Operator": "EQUAL"
                })
            }
        }

        EnlilAxiosRestAPI({
            method: "GET",
            url: "t3/v1/project_plan_phase_milestone_references",
            json: true,
            params: {
                "QBE": btoa(JSON.stringify(QBE))
            },
            headers: {
                "idoc-request": idocRequest,
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ProjectPlanPhaseMilestoneReferenceIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

}

export default ProjectPlanPhaseMilestoneReferenceLookupEnterpriseComponent;